import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { scrollToElement } from '../../../common/scroll';
import { useStableSearchParams } from '../../../hooks/useStableSearchParams';

export default function AutoScroll() {
  const { pathname } = useLocation();
  const [searchParams] = useStableSearchParams();

  const scrollTo = searchParams.get('scroll_to');
  const scrollMode = searchParams.get('scroll_mode');
  const t = searchParams.get('t');

  useLayoutEffect(() => {
    if (scrollMode !== 'none' && scrollTo) {
      scrollToElement(() => document?.getElementById(scrollTo), 10000);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [scrollTo, scrollMode, t, pathname]);

  return null;
}
